export default __webpack_public_path__ + "static/media/3.0a666c56.png";